var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.score !== null)?_c('li',{class:_vm.lineColorClass},[_vm._v(_vm._s(_vm.label[_vm.labelType]))]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }